/**
 * Created by pandemio on 11/8/18.
 */
import React from 'react';
import { Input } from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorState extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state = {
            options: [], // The options to fill the selection
            isoCode: this.props.data.stateRegion,
            countryIsoCode: this.props.data.country,
            mounted: false
        };
    }

    /**
     * Component will receive props. To receive the country ISOs
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        if(this.state.mounted == true) {
            this.setState({countryIsoCode: nextProps.data.country},
                ()=> {
                    this.callData();
                });
        }
    }

    componentDidMount()
    {
        this.setState({mounted:true});
    }

    /**
     * Call the data API
     */
    callData(){
        if(this.state.countryIsoCode != "0") {
            // This is promise
            let apiCall = ApiCalls.getStateProvinces(this.state.countryIsoCode);
            let arrOptions = [];
            let dataReturned;

            // Translate the first selection
            arrOptions.push(
                <option key={"0"} value={"0"}>
                    <Translate id="register.select-state" options={{renderInnerHtml: false}}/>
                </option>);

            // After the api call, fill the data
            apiCall.then((data)=> {
                dataReturned = data.StatesRegionsProvidences;
                // Now fill the selections
                for (let i = 0; i < dataReturned.length; i++) {
                    arrOptions.push(
                        <option key={dataReturned[i].IsoCode} value={dataReturned[i].IsoCode}>
                            { dataReturned[i].Name }
                        </option>
                    );
                }
            }).then(() => {
                this.setState({
                    options: arrOptions
                });
            });
        }
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (event) => {
        this.setState({value: event.target.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <div>
            {
                this.state.options.length > 0 ?
                <Input type="select" className="form-control" name="country" onChange={this.handleChange} value={this.props.value}>
                    {this.state.options}
                </Input> : null
            }
        </div>
        )
    }
}

export default SelectorState;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-state.js